export default "__VITE_ASSET__BOifujrY__"